import * as React from "react";
import * as Yup from "yup";
import axios from "axios";
import { Formik } from "formik";
import { mailDomainsBlacklist } from '../utils/utils.js';

const PORTAL_ID = '7284441';
const FORM_ID = 'cd731b32-2724-4986-9f9d-f405c3d90ae7';

function toFormGroupClass(field, state, error) {
  if (state.touched[field] && (state.errors[field] || error)) {
    return "pt-form-group pt-intent-danger";
  } else if (
    state.touched[field] &&
    state.values &&
    state.values[field] !== ""
  ) {
    return "pt-form-group pt-intent-success";
  } else {
    return "pt-form-group";
  }
} 

// function titleToggleJS(){
//     var titleToggle = document.getElementById("contactHeaderTitleContainer");
//     titleToggle.classList.add("hiddenContactHeader");
//     // console.log(titleToggle);
// } 

export class DemoFormLongPDF extends React.Component {

  state = { error: false,  mailError: false, submitted: false };

  validationSchema = Yup.object().shape({
  	name: Yup.string().required("Required"),
    company_size: Yup.string().required("Required"),   
    email: Yup.string()
      .email("Must be a valid email")
      .matches(mailDomainsBlacklist, "Company Email Only")
      .required("Required")
  });
  

  handleSubmit = async (values, { resetForm }) => {
  
    if (this.props.pdfUrl){
      window.open(this.props.pdfUrl,'_blank');
      resetForm({ values: "" })
    }

    const url = typeof window !== 'undefined' ? window.location.href : '';
    const pageTitle = typeof document !== 'undefined' ? document.title : '';

    const UTMparams = JSON.parse(sessionStorage.getItem('UTMparams'));  

    const fields = [
      {name: 'firstname', value: values.name},
      {name: 'email', value: values.email},
      {name: 'how did you hear about us?', value: values.note },
      {name: 'company_size', value: values.company_size}
    ]

    if (UTMparams && typeof UTMparams[0] === "string" ){
      fields.push({name: UTMparams[0], value: UTMparams[1]})

    } else if (UTMparams) {
      UTMparams.forEach(property => {
        fields.push({name: property[0], value: property[1]})
      })
    }

    const context = {
      pageUri: url,
      pageName: pageTitle
    }
    try {
      // ============ Sending to Hubspot ============ // 
      await axios.request({
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
        data: JSON.stringify({
          fields: fields,
          context: context
        })
      })
      
      this.setState({ submitted: true });

      /*
      this.btn.setAttribute("disabled", "disabled");
      this.btn.removeAttribute("disabled");
      */
    
    } catch (error) {
      this.setState({ error: true })
      return
    }

    axios 
      .request({
        method: "POST",
        url: "https://api.charthop.com/contact",
        data: {
          ...values, 
          source: this.props.source
          }
      })
  };

  render() {
    if (this.state.submitted && this.props.pdfUrl) {

      return (
       
        <div className="pt-callout pt-intent-primary sectionSpacing pb-0 pt-submission-success">
          <div className="successBunny"></div>        	
          <p className="white-font">Great! We'll email you with a copy.<br></br> <br></br>
          To download the PDF <a href={this.props.pdfUrl} target="_blank"><u>click here</u></a>.</p>
          {/* {titleToggleJS()} */}
        </div>
        
      );
    }

    if (this.state.submitted && !this.props.pdfUrl) {

      return (
       
        <div className="pt-callout pt-intent-primary sectionSpacing pb-0 pt-submission-success">
          <div className="successBunny"></div>          
          <p className="white-font">Great! We'll email you.<br></br> <br></br></p>
        </div>
        
      );
    }


    return (
      <Formik
       initialValues={{ name: "", email: "", company_size: "", note: "" }}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit} 
        render={form => (
          
          <form
            className="demolongform"
            onSubmit={form.handleSubmit}
          >
          
			<div className={toFormGroupClass("name", form)}>
              <label className="pt-label" htmlFor="name">
                Full Name
              </label>
              <input
                id="name"
                type="text"
                className="pt-input"
                value={form.values.name}
                onChange={form.handleChange}
                placeholder="Full Name"
              />
              {form.touched.name && form.errors.name && (
                <div className="pt-form-helper-text">{form.errors.name}</div>
              )}
            </div>

			 <div className={toFormGroupClass("email", form)} >
              <label className="pt-label" htmlFor="email">
                Company Email
              </label>
              <input
                id="email"
                type="email"
                value={form.values.email}
                onChange={form.handleChange}
                placeholder="Company Email"
              />
              {form.touched.email && form.errors.email && (
                <div className="pt-form-helper-text">{form.errors.email}</div>
              )}
              
            </div>
            
            <div className={toFormGroupClass("company_size", form)} >
              <label className="pt-label" htmlFor="company_size">
                How big is your company?
              </label>
             <select
				name="company_size"
				value={form.values.company_size}
				onChange={form.handleChange}
        onBlur={form.handleBlur}
        className="select-font"
			  >
			    <option value="" label="How big is your company?" className="select-font">How big is your company?</option>
					<option value="10" label="1-10" >1-10</option>
					<option value="50" label="10-50" >10-50</option>
					<option value="125" label="50-125" >50-125</option>
					<option value="250" label="125-250" >125-250</option>
					<option value="750" label="250-750" >250-750</option>
					<option value="1500" label="750-1500" >750-1500</option>
					<option value="5000" label="1500-5000" >1500-5000</option>
					<option value="10000" label="5000+" >5000+</option>
			   </select>
              {form.touched.company_size && form.errors.company_size && (
                <div className="pt-form-helper-text">{form.errors.company_size}</div>
              )}
              
            </div>            
            
            <div className="pt-form-group">
              <label className="pt-label" htmlFor="note">
                How did you hear about us?
              </label>
              <input
              	type="text"
                id="note"
                className="placeholder-fixed"
                value={form.values.note}
                onChange={form.handleChange}
                placeholder="How did you hear about us?"
              />
            </div>  
            
            {
              this.props.pdfUrl && (
                <button ref={btn => { this.btn = btn; }} type="submit" className="button primary">
                  DOWNLOAD
                </button>
              )
            }
            {
              this.props.pdfUrl && (
                <p className="p-formPDF opt-in pt-0 pb-0 mb-0">By downloading this PDF, you agree to opt-in to emails from ChartHop.</p>
              )
            }

            {
              !this.props.pdfUrl && (
                
                <button ref={btn => { this.btn = btn; }} type="submit" className="button primary">
                  REQUEST A DEMO
                </button>
              )
            }
            {
              !this.props.pdfUrl && (
                <p className="p-formPDF opt-in pt-0 pb-0 mb-0">By requesting a demo, you agree to opt-in to emails from ChartHop.</p>
              )
            }

            {this.state.mailError && (
              <div className="pt-callout pt-intent-danger" style={{ marginTop: 10 }}>
                Sorry! Please use a company email. If your issue persists, send a note to {" "}
                <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
              </div>
            )}


            {this.state.error && (
              <div
                className="pt-callout pt-intent-danger"
                style={{ marginTop: 10 }}
              >
                <p className="p-maxwidth errorTextHeaderForm"><span role="img" aria-label="warning">&#128680;</span>
                Sorry, but we had an unexpected problem submitting your request.
                Try again later, or send a note to{" "}
                <a href="mailto:hello@charthop.com">hello@charthop.com</a>.</p>
              </div>
            )}
          </form>
          
        )}
      />
    );
  }
}
